import Route from '@ember/routing/route';

export default class PasswordResetRoute extends Route {
  queryParams = {
    email: {
      refreshModel: true,
    },
  };
}
